import { render, staticRenderFns } from "./ProfileSettingsGeneral.vue?vue&type=template&id=56275a4a&scoped=true&"
import script from "./ProfileSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./ProfileSettingsGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSettingsGeneral.vue?vue&type=style&index=0&id=56275a4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56275a4a",
  null
  
)

export default component.exports